import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EnvelopeSimple, CheckCircle, ArrowLeft } from "@phosphor-icons/react";

export default function PasswortVergessen() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Anfrage fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-sm animate-fade-in" data-testid="forgot-password-page">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <EnvelopeSimple size={24} weight="bold" />
          </div>
          <div>
            <div className="font-heading text-lg font-black tracking-tight">Passwort vergessen</div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-muted-foreground">Zurücksetzen</div>
          </div>
        </div>

        {sent ? (
          <div className="space-y-4" data-testid="forgot-password-success">
            <div className="flex items-center gap-2 text-emerald-600">
              <CheckCircle size={22} weight="fill" />
              <span className="font-semibold">E-Mail versendet</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Falls die E-Mail-Adresse bei uns registriert ist, haben wir einen Link zum Zurücksetzen des Passworts
              gesendet. Der Link ist 60 Minuten gültig. Bitte prüfen Sie auch Ihren Spam-Ordner.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:underline">
              <ArrowLeft size={16} /> Zurück zur Anmeldung
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <p className="text-sm text-muted-foreground">
              Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
            </p>
            <div className="space-y-2">
              <Label className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">E-Mail</Label>
              <Input type="email" data-testid="forgot-password-email" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="h-12" />
            </div>
            {error && <p data-testid="forgot-password-error" className="text-sm font-medium text-danger">{error}</p>}
            <Button type="submit" data-testid="forgot-password-submit" disabled={loading || !email}
              className="h-12 w-full text-base font-semibold">
              {loading ? "Senden…" : "Reset-Link anfordern"}
            </Button>
            <Link to="/login" className="flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft size={16} /> Zurück zur Anmeldung
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
